// @flow

import type {Node} from 'react';

import {HeaderNew} from '@travel-frontend/ui-components';
import {Trans, useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {Navigate} from 'react-router-dom';

import {Footer, LoadingPageLayout} from 'components/Layout';
import {PageLoading as UIPageLoading} from 'components/PageLoading';
import {config} from 'config';
import {useBookStatus} from 'hooks/useBookStatus';
import {useDirectusHeader} from 'hooks/useDirectusHeader';
import {Checkout as NavigateCheckout} from 'modules/Common/Navigate/Checkout';
import {getJourneyId} from 'redux/uiState/layout/booking/reducer';

export const PageLoading = (): Node => {
  const {t} = useTranslation('general');

  const {headerConfig} = useDirectusHeader();

  const journeyId = useSelector(getJourneyId);
  const {bookingInProgress, booked, requestFailed} = useBookStatus(journeyId);

  if (requestFailed) {
    return <Navigate to="/" replace />;
  }

  if (!bookingInProgress && !booked) {
    return <NavigateCheckout path={`/${journeyId}`} />;
  }

  return (
    <LoadingPageLayout>
      <HeaderNew
        config={{
          login: false,
          sslIcon: true,
          logo: headerConfig.logo,
        }}
      />
      <UIPageLoading
        title={
          // $FlowFixMe
          <Trans
            i18nKey={`general:loading.confirm`}
            components={[
              // alternative object syntax could be used here
              // https://react.i18next.com/latest/trans-component#alternative-usage-which-lists-the-components-v11.6.0
              // eslint-disable-next-line react/jsx-key
              <br />,
            ]}
          />
        }
        message={t('general:loading.default')}
      />
      <Footer kind={'shortWithLinks'} config={config.footer} />
    </LoadingPageLayout>
  );
};
